import React from 'react';
import TextMessage from './text-message';
import Cards from './cards';
import Buttons from './buttons';
import ImageMessage from './image-message';

/**
 * Map a runtime message type onto a renderer.
 *
 * Types match the web-plugin's, so any agent built for the existing channel
 * renders here unchanged. Unknown types fall back to their raw payload rather
 * than rendering nothing.
 */
export default function BotMessageFactory(props) {
  const { type, message } = props;

  switch (type) {
    case 'TEXT':
      return <TextMessage {...props} />;
    case 'CARDS':
      return <Cards {...props} />;
    case 'BUTTONS':
      return <Buttons {...props} />;
    case 'IMAGE':
      return <ImageMessage {...props} />;
    default:
      if (typeof message === 'string') {
        return <TextMessage {...props} />;
      }
      return (
        <pre className="overflow-x-auto rounded-lg border border-hairline bg-surface p-3 font-mono text-[12px] text-ink-muted">
          {JSON.stringify(message, null, 2)}
        </pre>
      );
  }
}
